<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="paiming">
      外地企业中标率
    </div>
    <div class="paiming2">
      <p class="biaoti">
        外地企业中标率大连处于对标城市的中上水平,排名第2位;对标城市中企业开办成本最低为上海合计100元, 相差30元左右
      </p>
      <div class="paimingk">
        <div class="paiming3">
          <div class="head">
            <div class="item1">序号</div>
            <div class="item1">城市</div>
            <div class="item3">金额</div>
          </div>
          <div class="body">
            <div class="bodyitem" v-for="(item,index) in list" :key="index">
              <div class="item1">{{ index + 1 }}</div>
              <div class="item2">{{ item.title }}</div>
              <div class="item3">{{ item.fenshu }}元</div>
            </div>
          </div>
        </div>
        <div class="paiming4">
          <div id="huodexindai1" :style="{width: '550px', height: '300px'}"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "paiming",
  data: function () {
    return {
      list: [{
        title: '上海',
        day: 1,
        fenshu: 180
      }, {
        title: '大连',
        day: 1,

        fenshu: 172
      }, {
        title: '北京',
        day: 1,
        fenshu: 160
      }, {
        title: '深圳',
        day: 1,
        fenshu: 156
      }]
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('huodexindai1'))
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '5%',
          right: '0%',
          left: '18%',
          bottom: '19%'
        },
        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: ['北京', '上海', '深圳', '大连'],
          axisLabel: {
            margin: 20,
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 2
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          minInterval: 25,
          axisLabel: {
            formatter: '{value}分',
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#fff',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [90, 80, 85, 70],
          barWidth: '33px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(236, 141, 91, 1)'];
                return colorList[params.dataIndex];
              },
              barBorderRadius: [15, 15, 0, 0]
            },
          },
          label: {
            normal: {
              show: false,
              fontSize: 18,
              fontWeight: 'bold',
              color: '#333',
              position: 'top',
            }
          }
        }
        ]
      });
    }

  },
  mounted() {
    this.drawLine();

  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  margin-top: 20px;

}

.paiming2 {
  height: 456px;
  background: url("../../assets/kuangjialeft.png") left top no-repeat,
  url("../../assets/kuangjiabottom.png") right bottom no-repeat,
  rgba(35, 77, 205, 0.16);
  padding-top: 40px;

  .head {
    width: 558px;
    height: 63px;
    margin: auto;
    background: rgba(199, 203, 214, 1);
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 30%;
      @include flex_center_center();
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #0C1638;
    }

    .item3 {
      width: 40%;
    }
  }
}

.body {
  width: 560px;
  margin: auto;
}

.bodyitem {
  height: 58px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;

  .item1, .item2, .item3 {
    width: 30%;
    @include flex_center_center();
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item3 {
    width: 40%;
  }
}

.biaoti {
  height: 57px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin-left: 23px;
  margin-bottom: 30px;
}

.paimingk {
  @include flex_start_start();
  margin-left: 23px;
  margin-top: 30px;
}

.paiming4 {
  margin-left: 30px;
  @include flex_center_center();
}
</style>
